<template>
  <div class="top-common-attributes">
    <p class="top-common-attributes__title">Top 10 by coverage</p>
    <div class="top-common-attributes__y-title">Index to average</div>
    <div class="top-common-attributes__x-title">Coverage</div>
    <top-attributes-bubble-graph class="top-common-attributes__graph"
                                 ref="graph"
                                 :chartData="dataForGraph"
                                 :axises="axises"></top-attributes-bubble-graph>
  </div>
</template>

<script>
  import { ResizeSensor } from 'css-element-queries'
  import TopAttributesBubbleGraph from '@/appComponents/graphs/TopAttributesBubbleGraph'
  import { setDataForBubblesPlugin } from '@/appComponents/graphs/bubbleLabelPlugin'
  import { transformTopAttributesForGraph, topAttributesAxises } from '@/appComponents/workbench/lasGraphs/chartDataHelpers'

  export default {
    components: {
      TopAttributesBubbleGraph
    },
    props: {
      attributes: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    data () {
      return {
        overRideBubble: {
          min: 15,
          max: 90
        }
      }
    },
    computed: {
      dataForGraph () {
        // convert the raw data to what the graph wants
        return transformTopAttributesForGraph(this.attributes, this.overRideBubble)
      },
      axises () {
        return topAttributesAxises(this.attributes)
      }
    },
    methods: {
      resizeBubbleToWidth (updatedWidth) {
        // TODO: since it looks like these don't need to be a range anymore (they are all the same size bubble)
        // lets update this code to reflect that
        if (updatedWidth < 1281) {
          this.overRideBubble.max = 20
          this.overRideBubble.min = 19
        } else if (updatedWidth >= 1281) {
          this.overRideBubble.max = 35
          this.overRideBubble.min = 34
        }
      }
    },
    created () {
      setDataForBubblesPlugin(this.dataForGraph.datasets)
    },
    mounted () {
      const graph = this.$refs.graph.$el
      this.resizeBubbleToWidth(graph.clientWidth)
      ResizeSensor(graph, () => {
        const updatedWidth = graph.clientWidth
        this.resizeBubbleToWidth(updatedWidth)
      })
    },
    watch: {
      'dataForGraph': function () {
        // update the chart draw function with new data
        if (!this.dataForGraph) return
        setDataForBubblesPlugin(this.dataForGraph.datasets)
      }
    },
    beforeDestroy () {
      ResizeSensor.detach(this.$refs.graph.$el)
    }
  }
</script>

<style lang="scss">
  .top-common-attributes {
    &__graph {
      position: absolute;
      top: 15px;
      right: 0;
      bottom: 0;
      left: 0;
      height: calc(100% - 15px);
      width: 100%;
    }

    &__title {
      font-size: rem(12);
      text-align: center;
      text-transform: uppercase;
    }

    &__y-title {
      font-size: rem(13);
      color: color(grays, light);
      text-transform: uppercase;
      font-weight: bold;
      position: absolute;
      top: 50%;
      left: rem(-55);
      transform: rotate(-90deg);
    }

    &__x-title {
      font-size: rem(13);
      color: color(grays, light);
      text-transform: uppercase;
      font-weight: bold;
      bottom: rem(-8);
      left: 47%;
      position: absolute;
    }
  }
</style>



// WEBPACK FOOTER //
// TopCommonAttributes.vue?5c5deae2